import { Global } from "@emotion/react"
import { Box, Stack, styled, SwipeableDrawer } from "@mui/material"
import { grey } from "@mui/material/colors"
import { ReactElement, ReactNode } from "react"

interface IDrawerProps {
    open: boolean
    toggleDrawer: () => void
    mounted?: boolean
    children?: ReactNode
}

/**
 * A drawer that slides up from the bottom of the screen.
 *
 */
const Drawer = ({
    open,
    toggleDrawer,
    mounted,
    children,
}: IDrawerProps): ReactElement => {
    const drawerBleeding = 56

    const Puller = styled("div")(({ theme }) => ({
        width: 30,
        height: 6,
        backgroundColor: theme.palette.mode === "light" ? grey[300] : grey[900],
        borderRadius: 3,
        position: "absolute",
        top: 8,
        left: "calc(50% - 15px)",
    }))

    return (
        <>
            <Global
                styles={{
                    ".MuiDrawer-root > .MuiPaper-root": {
                        // update the percentage to increase the height of the drawer
                        height: `calc(30% - ${drawerBleeding}px)`,
                        overflow: "visible",
                    },
                }}
            />

            <SwipeableDrawer
                anchor="bottom"
                open={open}
                onClose={toggleDrawer}
                onOpen={toggleDrawer}
                swipeAreaWidth={drawerBleeding}
                disableSwipeToOpen={false}
                ModalProps={{
                    keepMounted: mounted,
                }}
                PaperProps={{
                    sx: {
                        borderTopLeftRadius: 16,
                        borderTopRightRadius: 16,
                    },
                }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        right: 0,
                        left: 0,
                    }}
                >
                    <Puller />
                </Box>
                <Box
                    sx={{
                        px: 2,
                        pb: 2,
                        height: "100%",
                        overflow: "auto",
                        marginTop: 4,
                    }}
                >
                    <Stack display="flex" flexDirection="column" spacing={3}>
                        {children}
                    </Stack>
                </Box>
            </SwipeableDrawer>
        </>
    )
}

Drawer.defaultProps = {
    children: null,
    mounted: false,
}

export default Drawer
